
export const styles = () => ({
  datePicker: {
    width: '100%',
    maxWidth: 300
  }
});

export default styles;
